/* Publish by EComposer at 2026-09-27 13:59:45*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-m6kn7hbxt1n"]=  window.__ectimmers["ecom-m6kn7hbxt1n"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-m6kn7hbxt1n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m6kn7hbxt1n', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pj6a85odxys"]=  window.__ectimmers["ecom-pj6a85odxys"] || {};
let e=this.$el.querySelector(".ecom-shopify__article__description-view-more-btn"),r=this.settings.content_type,s=this.$el.querySelector(".ecom-shopify__article__description--full"),l=this.$el.querySelector(".ecom-shopify__article__description--paragraph");e&&e.addEventListener("click",function(){r==="text"&&s?(s.style.display="inherit",l.style.display="none"):l.style.maxHeight=null,this.style.display="none"})

                    });
                    
                        document.querySelectorAll('.ecom-pj6a85odxys').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pj6a85odxys', settings: {"content_type":"html"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nll2jxlzv8"]=  window.__ectimmers["ecom-nll2jxlzv8"] || {};
var e=this.$el;if(e&&this.isLive){var t=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");t.length&&t.forEach(function(i){var a=i.getAttribute("href")||"#",r=a.replace("{current-link}",location.href);i.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-nll2jxlzv8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nll2jxlzv8', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}